import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { PageHeader } from "@/components/kit";
import { Card } from "@/components/ui/card";
import { CheckCircle2, CreditCard, DollarSign } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export default function AdminSettings() {
  const [mode, setMode] = useState(null);
  const [price, setPrice] = useState("");

  useEffect(() => { api.get("/settings").then(({ data }) => { setMode(data.scheduling_mode); setPrice(data.client_access_price ?? 17); }); }, []);

  const save = async (m) => {
    await api.put("/settings", { scheduling_mode: m });
    setMode(m);
    toast.success("Forma de agendamento atualizada");
  };
  const savePrice = async () => {
    await api.put("/settings", { client_access_price: parseFloat(price) || 0 });
    toast.success("Valor do acesso do cliente atualizado");
  };

  const Option = ({ value, icon: Icon, title, desc, testid }) => (
    <button onClick={() => save(value)} data-testid={testid}
      className={`text-left rounded-2xl border p-6 transition-all ${mode === value ? "border-primary ring-2 ring-primary/20 bg-primary/5" : "border-border hover:border-primary/40"}`}>
      <div className="flex items-center justify-between">
        <div className="w-11 h-11 rounded-xl bg-primary/10 text-primary flex items-center justify-center"><Icon className="w-5 h-5" /></div>
        {mode === value && <CheckCircle2 className="w-5 h-5 text-primary" />}
      </div>
      <h3 className="font-heading text-lg font-medium mt-4">{title}</h3>
      <p className="text-sm text-muted-foreground mt-1">{desc}</p>
    </button>
  );

  return (
    <div>
      <PageHeader title="Configurações da Plataforma" subtitle="Regras globais aplicadas a todos os hipnoterapeutas" />
      <Card className="p-6">
        <h3 className="font-heading text-lg font-medium">Forma de Agendamento</h3>
        <p className="text-sm text-muted-foreground mt-1 mb-6">Define como os clientes agendam consultas em toda a plataforma.</p>
        {mode !== null && (
          <div className="grid md:grid-cols-2 gap-4">
            <Option value="request" icon={CheckCircle2} title="Solicitação de Agendamento" testid="mode-request"
              desc="O cliente escolhe data e horário. O pedido é enviado ao hipnoterapeuta, que confirma manualmente. Nenhum pagamento é realizado na plataforma." />
            <Option value="online_payment" icon={CreditCard} title="Pagamento Online" testid="mode-online"
              desc="O cliente escolhe data e horário, visualiza o valor do profissional e realiza o pagamento. Após o pagamento, a consulta é confirmada automaticamente." />
          </div>
        )}
        <p className="text-xs text-muted-foreground mt-6">
          Arquitetura preparada para integração futura com gateways de pagamento (PIX, Cartão).
        </p>
      </Card>

      <Card className="p-6 mt-4">
        <h3 className="font-heading text-lg font-medium">Valor do Acesso do Cliente (autocadastro)</h3>
        <p className="text-sm text-muted-foreground mt-1 mb-4">Valor cobrado do cliente que se cadastra por conta própria para desbloquear os conteúdos.</p>
        <div className="flex items-end gap-3 max-w-sm">
          <div className="flex-1">
            <Label>Valor (R$)</Label>
            <div className="relative mt-1">
              <DollarSign className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
              <Input type="number" value={price} onChange={(e) => setPrice(e.target.value)} data-testid="client-price-input" className="pl-9" />
            </div>
          </div>
          <Button onClick={savePrice} className="rounded-full" data-testid="save-price-btn">Salvar</Button>
        </div>
      </Card>
    </div>
  );
}
